import anime from 'animejs';
import axios from 'axios/index';
/* custom helper */
import dateHelper from './narrowcasting/Date';
/* templates */
import { dropdownOptionSingle, selectedOption } from './../templates/dropdown.js';

/** ----------------------------------------
     Tickets
 ---------------------------------------- */

export class Tickets {

    constructor(host) {
        this.data = '';
        this.host = host;
        this.queryValue = {
            day: '',
            time: '',
            location: ''
        };
        this.selected = {};
        this.init();
    }

    /** ----------------------------------------
         Set Layer
     ---------------------------------------- */

    set() {
        let notification = document.querySelector('.tickets__notification');
        notification.remove();

        let filmTicketUlr = document.querySelector('.tickets').dataset.filmTicketUrl;

        if(filmTicketUlr) {
            let firstLocation = this.data[0][Object.keys(this.data[0])[0]];
            let buttonText = firstLocation[Object.keys(firstLocation)[0]][0]['text'];
            this.setButton(filmTicketUlr, buttonText);
            this.hideSelectors();
            this.open();
        } else {
            this.location();
            this.day();
            this.open();
        }


    }

    filmDate() {
        const premier = document.querySelector('#js-date');
        const date = new Date();
        const premierDate = new Date(premier.innerHTML);

        const lang = this.host.info.language !== 'nl' && 'eng' || this.host.info.language;

        return (premierDate > date) && this.dateFormat(premierDate, lang);
    }

    dateFormat(premier, type) {
        let day = dateHelper.getDay(premier.getDay(), type);
        let dayNumber = premier.getDate();
        let month = dateHelper.getMonth(premier.getMonth(), type);

        switch (type) {
            case 'nl':
                break;

            case 'eng':
                month = 'of ' + month;
                dayNumber = this.ordinalSuffix(dayNumber);
                break;
        }

        return `${day} ${dayNumber} ${month}`;
    }

    ordinalSuffix(i) {
        let j = i % 10,
            k = i % 100;

        if (j === 1 && k !== 11) {
            return i + 'st';
        } else if (j === 2 && k !== 12) {
            return i + 'nd';
        } else if (j === 3 && k !== 13) {
            return i + 'rd';
        }
        return i + 'th';
    }

    empty() {
        let options = document.querySelector('.tickets__options');
        options.remove();

        let date = this.filmDate();


        const premier = this.host.translate(`Eerste (of enige) vertoning op ${date.toLowerCase()} `, `First (or only) screening on ${date}`);
        const unavailable = this.host.translate('Er zijn (nog) geen tickets beschikbaar voor deze voorstelling', 'Unfortunately there are no tickets available (yet) for this movie');
        const message = date ? premier : unavailable;

        this.notification(message);
        this.open();
    }

    notification(content) {
        let notification = document.querySelector('.tickets__notification');
        let info = notification.querySelector('.notification__text');
        info.innerHTML = content;
    }

    open() {
        let tickets = document.querySelector('.tickets');
        let options = tickets.firstElementChild;
        let height = options.offsetHeight;

        let open = anime({
            targets: tickets,
            height: height,
            duration: 500,
            easing: 'easeOutQuad'
        });

        anime({
            targets: options,
            opacity: 1,
            delay: 350,
            duration: 500,
            easing: 'easeOutQuad'
        });

        open.finished.then(function () {
            tickets.style.height = 'auto';
            tickets.classList.add('is-open');
        });
    }

    location() {
        let locations = this.layer(this.data[0]);
        let dropdown = document.querySelector('#ticket-location');

        this.selected['location'] = locations[0];

        locations.map((loc, i) => {
            let data = {
                name: loc,
                value: loc
            };

            dropdown.insertAdjacentHTML('beforeend', dropdownOptionSingle(data, 'location', i));
        });

        this.locationEvent();
    }

    selectedLocation() {
        let dropdown = document.querySelector('#ticket-location');
        let dropdownOptions = document.querySelectorAll('.dropdown');
        let selected = this.selected['location'];
        const colors = dropdown.dataset.options ? JSON.parse(dropdown.dataset.options) : {};

        if (colors.hasOwnProperty(selected)) {
            for (var i = 0; i < dropdownOptions.length; i++) {
                dropdownOptions[i].classList.remove('lila', 'green', 'red');
                dropdownOptions[i].classList.add(colors[selected]);
            }
        }

        dropdown.parentNode.previousSibling.previousSibling.innerHTML = this.selected['location'];
    }

    locationEvent() {
        let dropdown = document.querySelector('#ticket-location');
        let options = dropdown.getElementsByTagName('input');

        [...options].map(option => {
            option.addEventListener('click', () => {
                this.selected['location'] = option.id;
                this.selectedLocation();
                this.day();
            });
        });

        this.selected['location'] = this.queryValue.location ? this.findLocation(options, this.queryValue.location) : options[0].id;

        this.selectedLocation();
        this.day();
    }

    findLocation(options, value) {
        for (let i = 0; i < options.length; i++) {
            if(value.toLowerCase() === options[i].id.toLowerCase())
                return options[i].id;
        }

        return options[0].id;
    }

    day() {
        let location = this.selected['location'];
        let days = this.layer(this.data[0][location]);
        let dropdown = document.querySelector('#ticket-days');

        dropdown.innerHTML = '';

        days.map((day, index) => {
            let data = {
                name: day,
                value: day
            };

            dropdown.insertAdjacentHTML('beforeend', dropdownOptionSingle(data, 'days', index));
        });

        this.dayEvent();
    }

    selectedDay() {
        let dropdown = document.querySelector('#ticket-days');
        dropdown.parentNode.previousSibling.previousSibling.innerHTML = this.selected['day'];
    }

    dayEvent() {
        let dropdown = document.querySelector('#ticket-days');
        let options = dropdown.getElementsByTagName('input');

        [...options].map(option => {
            option.addEventListener('click', () => {
                this.selected['day'] = option.id;
                this.selectedDay();
                this.time(option.id);
            });
        });

        this.selected['day'] = this.queryValue.day ? this.findDay(options, this.queryValue.day) : options[0].id;

        this.selectedDay();
        this.time();
    }

    findDay(options, value) {
        for (let i = 0; i < options.length; i++) {
            const optionDate = new Date();
            optionDate.setDate(parseInt(options[i].id.split(' ')[1], 10));
            optionDate.setMonth(dateHelper.getMonthNumber(options[i].id.split(' ')[2], this.host.info.language));

            if(value.getMonth() === optionDate.getMonth() && value.getDate() === optionDate.getDate())
                return options[i].id;
        }

        return options[0].id;
    }

    toggleTime(element) {
        element.classList.toggle('is-active');
    }

    getSiblings(element) {
        let parent = element.parentNode;
        return parent.children;
    }

    time() {
        let select = document.querySelector('#ticket-time');
        let location = this.selected['location'];
        let day = this.selected['day'];
        let times = this.data[0][location][day];

        select.innerHTML = '';

        times.map((time, index) => {
            let data = {
                name: time.time,
                value: time.time,
                ticket: time.link,
                text: time.text
            };

            select.insertAdjacentHTML('beforeend',
                this.queryValue.time ?
                    selectedOption(data, index, this.findTime(times, this.queryValue.time).time) :
                    selectedOption(data, index)
            );
        });

        let time = this.queryValue.time ?
            this.findTime(times, this.queryValue.time) :
            times[0];

        let link = time.link;
        let title = time.text;

        this.setButton(link, title);
        this.timeEvent();
    }

    findTime(selections, value) {
        for (let i = 0; i < selections.length; i++) {
            if(selections[i].time === value)
                return selections[i];
        }

        return selections[0];
    }

    timeEvent() {
        let dropdown = document.querySelector('#ticket-time');
        let options = dropdown.querySelectorAll('.dropdown__select');

        [...options].map(option => {
            option.addEventListener('click', () => {
                if(option.classList.contains('is-active'))
                    return;

                let siblings = this.getSiblings(option);

                [...siblings].map(select => {
                    select.classList.remove('is-active');
                });

                this.toggleTime(option);
                this.setButton(option.dataset.ticket, option.dataset.text);
            });
        });
    }

    setButton(url, title) {
        let button = document.querySelector('.tickets__button');
        button.href = url;
        button.textContent = title;
    }

    hideSelectors() {
        let options = document.querySelector('.tickets__options');
        let dropdowns = options.getElementsByClassName('dropdown');
        for(var i = 0; i < dropdowns.length; i++){
            let drop = dropdowns[i];
            drop.style.display = 'none';
        }
    }

    /** ----------------------------------------
        Retrieve Layer
     ---------------------------------------- */

    layer(data) {
        if(typeof data === 'object')
            return Object.keys(data);

        data.map(option => {
            this.selected[option] = [];
            return Object.keys(option);
        });
    }

    query() {
        let href = window.location.href;
        let matches = href.match(/(?=[a-zA-Z]+\=)(.*?)(?=^]|\&|$)/g);

        if(!matches)
            return;

        let types = matches.map(type => decodeURI(type.match(/(^.*)\=/)[1]));

        if(!types.includes('date') || !types.includes('time'))
            return;

        matches.reduce((array, query) => {
            let type = decodeURI(query.match(/(^.*)\=/)[1]);
            let value = decodeURI(query.match(/\=(.*)$/)[1]);
            this.setQuery(type, value);
        }, []);
    }

    setQuery(type, value) {
        const options = {
            location: (location) => this.setLocationQuery(location),
            date: (date) => this.setDateQuery(date),
            time: (time) => this.setTimeQuery(time)
        };

        options[type](value);
    }

    setLocationQuery(value) {
        this.queryValue.location = value;
    }

    setDateQuery(value) {
        this.queryValue.day = new Date(value);
    }

    setTimeQuery(value) {
        this.queryValue.time = value;
    }

    /** ----------------------------------------
        Get Feed
     ---------------------------------------- */

    getFeed(id) {
        let url = this.host.path + '/feed/' + this.host.info.language + '/film/' + id;

        axios.get(url)
            .then((response) => {
                this.data = [response.data];

                if(!Array.isArray(response.data)) {
                    this.query();
                    this.set();
                } else {
                    this.empty();
                }
            });
    }

    /** ----------------------------------------
        Init
     ---------------------------------------- */

    /**
     * This function is called within the
     * constructor and will initiate once the
     * class is loaded.
     */

    init() {
        let template = document.body.dataset.template;
        let id = document.body.dataset.film;

        if(!id && template !== 'movie')
            return;

        this.getFeed(id);
    }

}
